import moment from 'moment'

// Returns a date in the format YYYY-MM-DD or null if the date is invalid
const format = (d, f = 'YYYY-MM-DD HH:mm') => {
  if (d && moment(d).isValid()) return moment(d).format(f)
  return '-'
}

const dateIsPast = d => moment(d).isValid() && moment().diff(moment(d)) > 0

export default {
  format,
  dateIsPast,
}
